import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { permissionUseMutation } from "components/permission/hooks";
import PermissionConst from "../permission-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import Icons from "components/icons";

interface IPermissionActionFieldProps {
    permissionId: string;
    permissionName: string;
}

const PermissionActionField: React.FC<IPermissionActionFieldProps> = ({ permissionId, permissionName }) => {
    const navigate = useNavigate();

    const { _setMutationPermissionDelete, loadingMutationPermissionDelete } =
        permissionUseMutation.delete(permissionId);

    const items = [
        {
            label: <Localize>MENUS_DROP.Label_Edit</Localize>,
            key: "1",
            icon: <Icons.Edit />,
            onClick: () => navigate(`${PermissionConst.basePath}/${permissionId}`),
        },
        {
            key: "2",
            label: (
                <EntityRemoveButton
                    modalButton={
                        <span style={{ display: "flex", alignItems: "center" }}>
                            <Icons.Delete />{" "}
                            <Localize>MENUS_DROP.Label_Delete</Localize>
                        </span>
                    }
                    nameEntity={localizeByKey("ENTITY.Modal_Title_Permission")}
                    dataNameEntity={localizeByKey(permissionName)}
                    loading={loadingMutationPermissionDelete}
                    deleteMutation={_setMutationPermissionDelete}
                    variables={{
                        id: permissionId,
                    }}
                />
            ),
        },
    ];

    return (
        <Dropdown
            placement="bottomRight"
            menu={{ items }}
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default PermissionActionField;